const baseUrl = 'https://api.spacexdata.com/v3';

const GET_MISSIONS = `${baseUrl}/missions`;

const GET_ROCKETS = `${baseUrl}/rockets`;

export { GET_ROCKETS, GET_MISSIONS };

export default baseUrl;
